import { render, staticRenderFns } from "./VesselsList.vue?vue&type=template&id=0124db08"
import script from "./VesselsList.vue?vue&type=script&lang=js"
export * from "./VesselsList.vue?vue&type=script&lang=js"
import style0 from "./VesselsList.vue?vue&type=style&index=0&id=0124db08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports